import { callEdgeFunction } from '../supabase.client';

export type EnumEnv = 'dev' | 'staging' | 'production';

export interface EnumType {
  name: string;
  values: string[];
}
export interface EnumColumn {
  table: string;
  column: string;
}

export const enumAdminClient = {
  listTypes: (schema: EnumEnv) =>
    callEdgeFunction<EnumType[]>('enum-admin', { op: 'list_types', schema }),
  listColumns: (schema: EnumEnv, type_name: string) =>
    callEdgeFunction<EnumColumn[]>('enum-admin', { op: 'list_columns', schema, type_name }),
  addValue: (
    schema: EnumEnv,
    type_name: string,
    value: string,
    after?: string,
    confirmation?: string
  ) =>
    callEdgeFunction<{ ok: true }>('enum-admin', {
      op: 'add_value',
      schema,
      type_name,
      value,
      after,
      confirmation,
    }),
  renameValue: (
    schema: EnumEnv,
    type_name: string,
    oldVal: string,
    newVal: string,
    confirmation?: string
  ) =>
    callEdgeFunction<{ ok: true }>('enum-admin', {
      op: 'rename_value',
      schema,
      type_name,
      old: oldVal,
      new: newVal,
      confirmation,
    }),
  createType: (schema: EnumEnv, type_name: string, values: string[], confirmation?: string) =>
    callEdgeFunction<{ ok: true }>('enum-admin', {
      op: 'create_type',
      schema,
      type_name,
      values,
      confirmation,
    }),
  dropType: (schema: EnumEnv, type_name: string, confirmation?: string) =>
    callEdgeFunction<{ ok: true }>('enum-admin', {
      op: 'drop_type',
      schema,
      type_name,
      confirmation,
    }),
};
